import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowLeft, Leaf } from "lucide-react";

export const ScienceHeader = () => (
  <header className="sticky top-0 z-40 border-b border-border bg-background/85 backdrop-blur">
    <div className="mx-auto flex max-w-5xl items-center justify-between px-4 py-3 sm:px-6">
      <Link to="/" className="flex items-center gap-2" data-testid="science-logo-home">
        <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary/12 text-primary">
          <Leaf className="h-5 w-5" />
        </span>
        <span className="font-display text-lg font-semibold text-foreground">Ecentra</span>
      </Link>
      <Button asChild variant="ghost" size="sm">
        <Link to="/#menu" data-testid="science-back-menu">
          <ArrowLeft className="mr-1.5 h-4 w-4" /> Balik sa Menu
        </Link>
      </Button>
    </div>
  </header>
);
